export default class DataMappingQuery {

    public static CreateDataMapping = `mutation CreateDataMappingQuery($input: DataMappingInput) {
        createDataMapping(input: $input) {
            id
        }
    }`;

    public static DeleteDataMapping = `mutation DeleteDataMappingQuery($id: ID!) {
        deleteDataMapping(id: $id) {
            id
        }
    }`;

    public static GetDataMapping = `query GetDataMappingsQuery($projectId: String!) {
        getDataMappings(projectId:$projectId) {
            id
            projectId
            dataTerm
            replacement
        }
    }`;
}